module.exports = __webpack_public_path__ + "img/14_l_uk.2dc7e39e.svg";